class ProductPersonalisation extends HTMLElement {
  constructor() {
    super();

    const personalisationInput = document.querySelector('#personalisation');
    this.radios = this.querySelectorAll('input[type="radio"]');
    this.radios.forEach((radio) => radio.addEventListener('change', () => this.togglePersonalisation(radio)));
    this.checkState();

    personalisationInput.addEventListener('keyup', () => {
      personalisationInput.value.length > 0 ? disableProductCTA(false) : disableProductCTA(true);
    });
  }

  checkState() {
    let initialpersonalisedVariant = document.querySelector('.personalisation-variant[value=Yes');
    const personalisationContainer = document.querySelector('.product-form__personalisation');
    if (initialpersonalisedVariant && initialpersonalisedVariant.checked) {
      const personalisationYes = document.querySelector('#personalisation-yes');

      if (personalisationYes) {
        personalisationYes.click();
      }
      disableProductCTA(true);
      this.enablePersonalisationBox(true);
    } else {
      disableProductCTA(false);
      this.enablePersonalisationBox(false);
    }
  }

  togglePersonalisation(radio) {

    const personalisationInput = document.querySelector('#personalisation');
    const personalisedVariant = document.querySelector('.personalisation-variant[value=Yes');

    if (personalisationInput) {

      if (personalisedVariant) {
        personalisedVariant.click();
      }

      updatePrice();

    }

    if (radio.value == 'yes') {
      this.enablePersonalisationBox(true);
    } else {
      this.enablePersonalisationBox(false);
    }
  }

  enablePersonalisationBox(state){
    const personalisationInput = document.querySelector('#personalisation');
    const personalisedVariant = document.querySelector('.personalisation-variant[value=Yes]');
    const personalisationContainer = document.querySelector('.product-form__personalisation');
    const nonPersonalisedVariant = document.querySelector('.personalisation-variant[value=No]');
    if(state == true){
      if (personalisationContainer) {
        personalisationContainer.classList.remove('hidden');
      }

      if (personalisationInput) {
        personalisationInput.removeAttribute("disabled");
      }
      if(personalisationInput.value.length > 0){
        disableProductCTA(false);
      } else {
        disableProductCTA(true);
      }
      
    } else {
      if (personalisationContainer) {
        personalisationContainer.classList.add('hidden');
      }

      if (personalisationInput) {
        personalisationInput.setAttribute("disabled", "true");
        personalisationInput.value = '';
      }

      if (nonPersonalisedVariant) {
        nonPersonalisedVariant.click();
      }

      disableProductCTA(false);
    }
  }
}
customElements.define('product-personalisation', ProductPersonalisation);
